Object.defineProperty(exports, '__esModule', { value: true });
var styles_1 = require('@material-ui/core/styles');
var React = require('react');
var recompose_1 = require('recompose');
var TapBackground_1 = require('../TapBackground');
var SdfBackground_1 = require('../SdfBackground');
var OilSteelBackground_1 = require('../OilSteelBackground');
var TritecnicaBackground_1 = require('../TritecnicaBackground');
var TriolietBackground_1 = require('../TriolietBackground');
var styles = function(theme) {
  return styles_1.createStyles({
    '@global': {
      body: {
        backgroundColor: '#F4F4F4',
        height: '100%',
        margin: 0,
      },
    },
  });
};
var PlatformPublicLayout = function(props) {
  var fullScrollMode = props.fullScrollMode, children = props.children, onClick = props.onClick,
    hideLogo = props.hideLogo, _a = props.tenantName, tenantName = _a === void 0 ? 'fallBack' : _a,
    _b = props.imagesBaseUrl,
    imagesBaseUrl = _b === void 0 ? 'https://tapprodstoragecommon.blob.core.windows.net/graphic-resources' : _b;
  var mainContainerStyle = {
    overflowY: fullScrollMode ? 'auto' : 'hidden',
  };
  var mapByTenant = {
    topcon: TapBackground_1.TapBackground,
    sdf: SdfBackground_1.SdfBackground,
    oilsteel: OilSteelBackground_1.OilSteelBackground,
    tritecnica: TritecnicaBackground_1.TritecnicaBackground,
    trioliet: TriolietBackground_1.TriolietBackground,
  };
  var PageBackground = mapByTenant[tenantName];
  return (React.createElement('div', { onClick: onClick, style: mainContainerStyle },
    React.createElement(PageBackground, { hideLogo: hideLogo, imagesBaseUrl: imagesBaseUrl }, children)));
};
exports.default = recompose_1.compose(styles_1.withStyles(styles))(PlatformPublicLayout);
//# sourceMappingURL=PlatformPublicLayout.js.map
